<template>
  <div>
    <div class="modal-title" v-if="isFirstRecommendationInGroup">
      <span :style="titleStyle">{{ titleTranslate }}</span>
    </div>
    <div class="modal-subtitle">
      <span :style="subTitleStyle">{{ subtitleTranslate }}</span>
    </div>
    <product-block v-for="productBlock in productRecommendation.childProducts"
                   :key="productBlock.menuProductGuid"
                   v-bind="productBlock"
                   :extra-props="extraProps"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { MultiLanguageText, TextProps } from '../models';

export default {
  name: 'recommendation-block',
  components: { ProductBlock: () => import('./ProductBlock.vue') },
  props: {
    productRecommendation: {
      type: Object,
      required: true,
      default: () => {
      }
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters(['selectedLanguage']),
    isFirstRecommendationInGroup() {
      return this.index === 0;
    },
    title() {
      return new MultiLanguageText(this.productRecommendation.parentProductName);
    },
    subtitle() {
      return new MultiLanguageText(this.productRecommendation.text);
    },
    titleTranslate() {
      return this.title.getText(this.selectedLanguage);
    },
    subtitleTranslate() {
      return this.subtitle.getText(this.selectedLanguage);
    },
    titleStyle() {
      const textProperties = new TextProps(this.productRecommendation.modalTitleTextProperties);
      return { 'font-weight': 'bold', ...textProperties.getStyles() };
    },
    subTitleStyle() {
      const textProperties = new TextProps(this.productRecommendation.modalSubtitleTextProperties);
      return { 'font-style': 'italic', 'font-weight': 'bold', ...textProperties.getStyles() };
    },
    extraProps() {
      return {
        visible: true,
        special: false,
      };
    },

  },
};
</script>
<style scoped>
.modal-title {
  padding: 3px;
  display: flex;
  justify-content: center;
}

.modal-subtitle {
  display: flex;
  justify-content: center;
}
</style>
